var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37259 0 0 5.37256 0 12C0 18.6274 5.37259 24 12 24C18.6274 24 24 18.6274 24 12C23.9928 5.37561 18.6245 0.00720215 12 0ZM12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19ZM13 13.837C12.9998 13.4392 13.2354 13.0791 13.6 12.92V12.921C15.431 12.1219 16.3917 10.0944 15.8504 8.17126C15.3092 6.24817 13.432 5.01929 11.453 5.29248C9.47397 5.5658 7.99997 7.2572 8 9.255C8 9.80725 8.44772 10.255 9 10.255C9.55228 10.255 10 9.80725 10 9.255C9.99948 8.25598 10.7362 7.40979 11.7258 7.27283C12.7154 7.13586 13.6543 7.75024 13.9251 8.71179C14.1959 9.67346 13.7156 10.6874 12.8 11.087C11.7066 11.5642 10.9998 12.644 11 13.837C11 14.3893 11.4477 14.837 12 14.837C12.5523 14.837 13 14.3893 13 13.837Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/questionCircle.ca696f76.svg";
export { ForwardRef as ReactComponent };